// extracted by mini-css-extract-plugin
module.exports = {"header":"RegisterLayout_header__KUHQW","logo":"RegisterLayout_logo__B8m3M"};